import { twMerge } from 'tailwind-merge';
import { typographyVariants, type TypographyVariants } from './variants';
import { type ElementType, type ReactNode } from 'react';

type Props = {
  as?: ElementType;
  children: ReactNode;
  className?: string;
} & TypographyVariants;

export function Typography(props: Props) {
  const {
    as: Tag = 'span',
    variant = 'body-m',
    weight = 'regular',
    useCase = undefined,
    children,
    className,
    ...rest
  } = props;

  return (
    <Tag
      className={twMerge(
        className,
        typographyVariants({ variant, weight, useCase }),
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
